import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/removal-items';

export default {
    get_all(payload) {
        return axios.get(`${RESOURCE_NAME}/`, {params: {legacy: payload}})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { "removal_header_id": payload })
    },
    select() {
        return axios.post(`${RESOURCE_NAME}/select`)
    },
};